import React from 'react'
import PropTypes from 'prop-types'
import { object } from 'common/helpers'

import Button from 'components/buttons/Button/Button'

import messages from './messages'


const titleKeys = [
  'accept',
  'back',
  'next',
  'choose',
  'cancel',
  'close',
  'confirm',
  'decline',
  'finish',
  'login',
  'reject',
  'save',
  'redeem',
  'submit',
  'resubscribe',
  'subscribe',
  'subscribeNow',
  'unsubscribe',
  'upgrade',
  'orderNow',
  'shopNow',
  'buyNow',
  'gotIt',
  'discoverNow',
  'chooseNow',
  'getStarted',
  'getTheOffer',
  'signMeUp',
  'joinToday',
  'resetPassword',
  'update',
  'continue',
  'neverMind',
  'send',
  'imIn',
]

const CommonButton = ({ className, title, ...props }) => {
  const titleKey  = titleKeys.filter((key) => Boolean(props[key]))[0]
  const rest      = object.removeKeys.call(null, props, ...titleKeys)

  if (!titleKey) {
    throw new Error(`There is no translation for key "${titleKey}" in CommonButton component`)
  }

  return (
    <Button
      className={className}
      title={title || messages[titleKey]}
      dataTestId={`${titleKey}Button`}
      {...rest}
    />
  )
}

CommonButton.propTypes = {
  id: PropTypes.string,
  h: PropTypes.number,
  title: PropTypes.object,
  ...Button.propTypes,
}


export default CommonButton
